import { Layers, Clock, MapPin, Settings, Play, Square, Pause } from 'lucide-react';

export default function FloatingNavBar({
  isRecording,
  isPaused,
  onRecord,
  onPause,
  onStop,
  onLayers,
  onHistory,
  onWaypoints,
  onSettings,
}) {
  return (
    <nav
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[1000] flex items-center gap-2 sm:gap-4 glass-panel rounded-full px-3 sm:px-5 py-2.5 shadow-2xl"
      data-testid="floating-nav"
    >
      <NavButton
        icon={<Layers size={20} strokeWidth={1.5} />}
        onClick={onLayers}
        testId="nav-layers-btn"
        label="Layers"
      />
      <NavButton
        icon={<Clock size={20} strokeWidth={1.5} />}
        onClick={onHistory}
        testId="nav-history-btn"
        label="History"
      />

      {/* Center record button */}
      <div className="flex items-center gap-1.5">
        {isRecording && (
          <button
            onClick={onPause}
            className="size-10 rounded-full flex items-center justify-center bg-secondary/80 text-foreground transition-all active:scale-95 hover:bg-secondary"
            data-testid="nav-pause-btn"
            aria-label={isPaused ? 'Resume' : 'Pause'}
          >
            {isPaused ? <Play size={16} /> : <Pause size={16} />}
          </button>
        )}
        <button
          onClick={isRecording ? onStop : onRecord}
          className={`size-14 rounded-full flex items-center justify-center transition-all active:scale-95 ${
            isRecording
              ? 'bg-lime-500 text-black recording-pulse'
              : 'bg-orange-500 text-white shadow-[0_0_20px_rgba(249,115,22,0.4)]'
          }`}
          data-testid="nav-record-btn"
          aria-label={isRecording ? 'Stop recording' : 'Start recording'}
        >
          {isRecording ? <Square size={18} fill="currentColor" /> : <Play size={20} fill="currentColor" />}
        </button>
      </div>

      <NavButton
        icon={<MapPin size={20} strokeWidth={1.5} />}
        onClick={onWaypoints}
        testId="nav-waypoints-btn"
        label="Waypoints"
      />
      <NavButton
        icon={<Settings size={20} strokeWidth={1.5} />}
        onClick={onSettings}
        testId="nav-settings-btn"
        label="Settings"
      />
    </nav>
  );
}

function NavButton({ icon, onClick, testId, label }) {
  return (
    <button
      onClick={onClick}
      className="size-10 rounded-full flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/10 transition-all active:scale-95"
      data-testid={testId}
      aria-label={label}
    >
      {icon}
    </button>
  );
}
